import client from "utils/api";
import store from 'utils/store'


function getAdventures(account){
  return client().get("/accounts/"+account.id+"/adventures")
    .then((response) => {
      store.dispatch({
        type:"ADD_ADVENTURES",
        payload: response.data
      })
      return response.data
    })
    .catch(e => {
      store.dispatch({type:"ADD_TOAST", id:"connection-problem", message:"There was a problem connecting to the server."})

    });
}

function editAdventure(adventure, params){
  return client().put("/accounts/"+adventure.account.id+"/adventures/"+adventure.id, params)
    .then((response) => {
      store.dispatch({
        type:"EDIT_ADVENTURE",
        payload: response.data
      })
      return response.data
    })
    .catch(e => {
      store.dispatch({type:"ADD_TOAST", id:"connection-problem", message:"There was a problem connecting to the server."})

    });
}
function deleteAdventure(adventure){
  return client().delete("/accounts/"+adventure.account.id+"/adventures/"+adventure.id)
    .then((response) => {
      store.dispatch({
        type:"DELETE_ADVENTURE",
        payload: {id:adventure.id}
      })
      return response.data
    })
    .catch(e => {
      store.dispatch({type:"ADD_TOAST", id:"connection-problem", message:"There was a problem connecting to the server."})

    });
}

export default {
  getAdventures,
  editAdventure,
  deleteAdventure
}



// WEBPACK FOOTER //
// ./src/components/account_page/adventures/api.js